export default __webpack_public_path__ + "assets/webgl/texture1.jpg.astc.7bc8046a.ktx";